import React, { Component } from "react";

import Publication from "../components/Publication";

import FrontPage from "../assets/images/publications/Developmental_Neurobiology_Special_Issue_Cover_Image_May_2019_Published.png";
import GrowthSpinalCord from "../assets/images/publications/Growth_Spinal_Cord.png";
import StochasticCellular from "../assets/images/publications/Stochastic_Cellular.png";
import StochasticCellularTumor from "../assets/images/publications/Stochastic_Cellular_Tumor.png";
import CellularAutomataModeling from "../assets/images/publications/Cellular_Automata_Modeling.png";
import AdultSpinalTissue from "../assets/images/publications/2020lehotzky.png";
import OtherLabPublication from "../components/OtherLabPublication";

class PublicationsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      publications: [
        {
          name:
            "Cover of Special Issue of Developmental Neurobiology Vol. 79, No. 5, May 2019, showing a simulated neurosphere based on cellular automata modeling (simulation and artistic work by D. Lehotzky and G.K.H. Zupanc)",
          image: FrontPage,
          link: "https://onlinelibrary.wiley.com/toc/1932846x/2019/79/5",
        },
        {
          name:
            "Growth of adult spinal cord in knifefish: development and parametrization of a distributed model. Journal of Theoretical Biology 437, 101-114 (2018)",
          image: GrowthSpinalCord,
          link: "https://doi.org/10.1016/j.jtbi.2017.10.012",
        },
        {
          name:
            "Stochastic cellular automata model of neurosphere growth: roles of proliferative potential, contact inhibition, cell death, and phagocytosis. Journal of Theoretical Biology 445, 151-165 (2018)",
          image: StochasticCellular,
          link: "https://doi.org/10.1016/j.jtbi.2018.02.025",
        },
        {
          name:
            "Stochastic cellular automata model of tumorous neurosphere growth: roles of developmental maturity and cell death. Journal of Theoretical Biology 467, 100-110 (2019)",
          image: StochasticCellularTumor,
          link: "https://doi.org/10.1016/j.jtbi.2019.01.028",
        },
        {
          name:
            "Cellular automata modeling of stem-cell-driven development of tissue in the nervous system. Developmental Neurobiology 79, 497-517 (2019)",
          image: CellularAutomataModeling,
          link: "https://doi.org/10.1002/dneu.22686",
        },
        {
          name:
            "Cellular automata modeling suggests symmetric stem-cell division, cell death, and cell drift as key mechanisms driving adult spinal cord growth in teleost fish. Journal of Theoretical Biology (2020)",
          image: AdultSpinalTissue,
          link: "https://doi.org/10.1016/j.jtbi.2020.110474",
        },
      ],
      publicationsOtherLabs: [
        {
          description:
            "The original research study through which Reynolds and Weiss established the neurosphere assay.",
          articles: [
            {
              article:
                "Reynolds BA, Weiss S. 1992. Generation of neurons and astrocytes from isolated cells of the adult mammalian central nervous system. Science 255: 1707-1710.",
              link: "https://pubmed.ncbi.nlm.nih.gov/1553558/",
            },
          ],
        },
        {
          description:
            "This article reviews some of the milestones of research on neural stem cells.",
          articles: [
            {
              article:
                "Gage FH, Temple S. 2013. Neural stem cells: Generating and regenerating the brain. Neuron 80: 588-601.",
              link: "https://pubmed.ncbi.nlm.nih.gov/24183012/",
            },
          ],
        },
        {
          description:
            "This review article discusses the two strategies of stem cells to accommodate self-renewal and to produce cells that differentiate.",
          articles: [
            {
              article:
                "Morrison SJ, Kimble, J. 2006. Asymmetric and symmetric stem-cell divisions in development and cancer. Nature 441: 1068-1074.",
              link: "https://pubmed.ncbi.nlm.nih.gov/16810241/",
            },
          ],
        },
        {
          description:
            "These three papers present descriptive and experimental studies on the regulation of mitosis and cell death by contact inhibition.",
          articles: [
            {
              article:
                "Eagle H, Levine EM. 1967. Growth regulatory effects of cellular interaction. Nature 213: 1102-1106.",
              link: "https://pubmed.ncbi.nlm.nih.gov/6029791/",
            },

            {
              article:
                "Eisenhoffer GT, Rosenblatt J. 2013. Bringing balance by force: Live cell extrusion controls epithelial cell numbers. Trends Cell Biol. 23: 185-192.",
              link: "https://pubmed.ncbi.nlm.nih.gov/23273931/",
            },

            {
              article:
                "Streichan SJ, Hoerner CR, Schneidt T, Holzer D, Hufnagel L. 2014. Spatial constraints control cell proliferation in tissues. Proc. Natl. Acad. Sci. USA 111: 5586-5591.",
              link: "https://pubmed.ncbi.nlm.nih.gov/24706777/",
            },
          ],
        },
        {
          description:
            "These three papers summarize the evidence that apoptosis of neural stem/progenitor cells occurs shortly after mitotic division in one of the two daughter cells, whereas the other survives and potentially continues to proliferate or differentiates. The study described in the first paper has provided evidence that this differential fate of the two daughter cells is regulated by asymmetric distribution of pro- and anti-apoptotic proteins during the final stages of mitosis.",
          articles: [
            {
              article:
                "Bieberich E, MacKinnon S, Silva J, Noggle S, Condie BG. 2003. Regulation of cell death in mitotic neural progenitor cells by asymmetric distribution of prostate apoptosis response 4(PAR-4) and simultaneous elevation of endogenous ceramide. J. Cell Biol. 162: 469-479.",
              link: "https://pubmed.ncbi.nlm.nih.gov/12885759/",
            },
            {
              article:
                "Kuan C - Y, Roth KA, Flavell RA, Rakic P. 2000. Mechanisms of programmed cell death in the developing brain. Trends Neurosci. 23: 291-297.",
              link: "https://pubmed.ncbi.nlm.nih.gov/10856938/",
            },
            {
              article:
                "Sommer L, Rao M. 2002. Neural stem cells and regulation of cell number. Prog. Neurobiol. 66: 1-18.",
              link: "https://pubmed.ncbi.nlm.nih.gov/11897403/",
            },
          ],
        },
        {
          description:
            "These two review articles put forward the hypothesis that the cellular origin of gliomas in the brain are adult neural stem cells and/or progenitor cells.",
          articles: [
            {
              article:
                "Sanai N, Alvarez - Buylla A, Berger MS. 2005. Neural stem cells and the origin of gliomas. N. Engl. J. Med. 353: 811-822.",
              link: "https://pubmed.ncbi.nlm.nih.gov/16120861/",
            },
            {
              article:
                "Vescovi AL, Galli R, Reynolds BA. 2006. Brain tumour stem cells. Nat. Rev. Cancer 6: 425-436.",
              link: "https://pubmed.ncbi.nlm.nih.gov/16723989/",
            },
          ],
        },
      ],
    };
  }
  componentWillMount() {
    document.title = "Publications";
  }

  render() {
    return (
      <div className="page-container container pt-4">
        <a name="skipnav" id="skipnav">
          <h1>Publications</h1>
        </a>
        <h2>Publications by the Laboratory of Neurobiology</h2>
        <div className="p-2">
          The Neurosphere Simulator is based on research carried out by the
          Laboratory of Neurobiology at Northeastern University. Click on the
          journal cover or the bibliographic information to be redirected to the
          respective publication.
        </div>
        <br />
        <div className="text-center justify-content-center">
          <div className="row">
            <div className="col-md-6">
              <Publication
                publication={this.state.publications[0]}
                first={true}
              />
            </div>
            <div className="col-md-6">
              {this.state.publications.slice(1).map((p) => (
                <Publication publication={p} />
              ))}
            </div>
          </div>
        </div>
        <h2 className="pt-5">Publications by Other Laboratories</h2>
        <br />
        <div>
          {this.state.publicationsOtherLabs.map(function (group) {
            return (
              <div className="col">
                <h3 className="py-2" style={{ fontSize: "1.25rem" }}>
                  {group.description}
                </h3>
                <ul>
                  {group.articles.map(function (article) {
                    return <OtherLabPublication publication={article} />;
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default PublicationsPage;
